// extracted by mini-css-extract-plugin
export default {"list":"GeneralStatistic_list__92FpF","select":"GeneralStatistic_select__hVg8x","area":"GeneralStatistic_area__9nRqf"};